module.exports = __webpack_public_path__ + "img/hubei.0b348cc4.png";